module.exports = __webpack_public_path__ + "img/hand-with-gloves-holding-gutter.fabe842c.jpg";